import merge from 'lodash/merge';
import { getGlobalAppVar } from '../global-app';

const DEFAULT_ASSET_VERSION = 42;
const defaultPreferences = {
  debug: false,
  assetVersion: DEFAULT_ASSET_VERSION,
};

let preferences = {};

export type Config = {
  cdnImage: boolean;
  contactMail: string;
  google: {
    appId: string;
    maps: {
      apiKey: string;
    };
    tagManager: {
      containerId: string;
      auth: string;
      preview: string;
    };
  };
  facebook: {
    appId: number;
  };
  apple: {
    appId: string;
  };
  algolia: {
    appId: string;
    learningContentApiKey: string;
    anonymizedApprenticesApiKey: string;
    publicJobPostingsApiKey: string;
  };
  opentok: {
    apiKey: number;
  };
  mapbox: {
    account: string;
    careerSurvey: string;
    studentApplication: string;
  };
  openclassrooms: {
    api: {
      anonymous: {
        client_id: string;
        client_secret: string;
      };
      logged: {
        client_id: string;
      };
      urls: {
        authorize: string;
        root: string;
        proxy: string;
      };
    };
  };
};

/**
 * @deprecated Use getAllConfig instead.
 */
export const getPreferences = () => {
  return merge({}, defaultPreferences, getGlobalAppVar().preferences, preferences) as Record<
    string,
    any
  >;
};

/**
 * @param {string} key
 * @deprecated Use getConfig instead.
 * @returns *
 */
export const getPreference = (key: string | keyof Config) => getPreferences()[key];

export const getAllConfig = getPreferences;
export const getConfig = getPreference;

export const setPreferences = (config: Config) => {
  preferences = merge(preferences, config);
};

/**
 * @param {string} key
 * @returns boolean
 */
export const isActivated = (key: string | keyof Config) => Boolean(getPreference(key));

export default {
  getPreferences,
  getPreference,
  getConfig,
  getAllConfig,
  isActivated,
};

export interface ConfigContextType {
  getConfig: <K extends keyof Config>(key: K) => Config[K];
  config: Config;
}

export function createConfigContext(config: Config) {
  const context: ConfigContextType = {
    config,
    getConfig: <K extends keyof Config>(key: K) => config[key],
  };

  return context;
}
